import { render } from "./BuybackSettings.vue?vue&type=template&id=acd3fa50&scoped=true&ts=true&lang=pug"
import script from "./BuybackSettings.vue?vue&type=script&lang=ts"
export * from "./BuybackSettings.vue?vue&type=script&lang=ts"

import "./BuybackSettings.vue?vue&type=style&index=0&id=acd3fa50&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acd3fa50"]])

export default __exports__